import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("slabstory_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authAPI = {
  register: (data) => api.post("/auth/register", data),
  login: (data) => api.post("/auth/login", data),
  getMe: () => api.get("/auth/me"),
  googleSession: (sessionId) => api.post("/auth/google/session", { session_id: sessionId }),
  logout: () => api.post("/auth/logout"),
};

export const propertyAPI = {
  list: (params) => api.get("/properties", { params }),
  featured: () => api.get("/properties/featured"),
  counts: () => api.get("/properties/counts"),
  detail: (id) => api.get(`/properties/${id}`),
  toggleSave: (id) => api.post(`/properties/${id}/save`),
  getSaved: () => api.get("/user/saved-properties"),
};

export const inquiryAPI = {
  create: (data) => api.post("/inquiries", data),
};

export const contactAPI = {
  create: (data) => api.post("/contact", data),
};

export const chatAPI = {
  send: (data) => api.post("/chat", data),
};

export const statsAPI = {
  get: () => api.get("/stats"),
};

export const adminAPI = {
  listProperties: (params) => api.get("/admin/properties", { params }),
  createProperty: (data) => api.post("/admin/properties", data),
  updateProperty: (id, data) => api.put(`/admin/properties/${id}`, data),
  deleteProperty: (id) => api.delete(`/admin/properties/${id}`),
  listInquiries: (params) => api.get("/admin/inquiries", { params }),
  updateInquiry: (id, data) => api.put(`/admin/inquiries/${id}`, data),
  exportInquiries: () => api.get("/admin/inquiries/export", { responseType: "blob" }),
};

export default api;
